export default __webpack_public_path__ + "static/media/datePickerActive.06745206.svg";